// extracted by mini-css-extract-plugin
export default {"article":"CompanyInfo_article__4VNSc"};